import { Injectable } from '@angular/core';
import { Commitment } from '@models/commitment.model';
import BaseService from './base.service';

@Injectable({
  providedIn: 'root'
})
export class CommitmentService extends BaseService<Commitment> {}
